export const getRequiredProductVariantBySku = (variants, sku) => variants.find((variant) => variant.sku === sku) ||
    variants.find((variant) => variant.stock !== 0) ||
    variants[0];
